import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';

import { OAuthModuleConfig, OAuthResourceServerErrorHandler, OAuthStorage } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { TokenService } from './token.service';

const allowedUrls = [environment.apiBioUrl, environment.apiDocUrl, environment.apiUrl];

@Injectable()
export class RoleInterceptor implements HttpInterceptor {
  constructor(
    private authStorage: OAuthStorage,
    private tokenService: TokenService,
    private errorHandler: OAuthResourceServerErrorHandler,
    @Optional() private moduleConfig: OAuthModuleConfig,
  ) {
    //super(tokenService['auth'], tokenService['errorHandler'], tokenService['moduleConfig']);
  }

  private checkUrl(url: string): boolean {
    // this.publicUrlService.isPublic(url) && !this.tokenService.hasValidToken();
    let found = this.moduleConfig!.resourceServer!.allowedUrls?.find(
      (u) => url.startsWith(u) || (url.startsWith('/') && url.includes(u)),
    );

    return !!found;
  }

  private checkUrl2(url: string): boolean {
    let found = this.moduleConfig!.resourceServer!.allowedUrls?.find((u) => url.startsWith(u));
    return !!found;
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url.toLowerCase();

    if (!this.moduleConfig) return next.handle(req);
    if (!this.moduleConfig.resourceServer) return next.handle(req);
    if (!this.moduleConfig.resourceServer.allowedUrls) return next.handle(req);
    if (!this.checkUrl(url)) return next.handle(req);

    // if (this.publicUrlService.isPublic(url) && !this.tokenService.hasValidToken()) {
    //   console.log('🔓 Public request, skipping token injection');
    //   return next.handle(req);
    // }

    let sendAccessToken = this.moduleConfig.resourceServer.sendAccessToken;
    if (!sendAccessToken) {
      console.error('🔐 No token available, forwarding request without token');
    }

    if (sendAccessToken) {
      let token = this.tokenService.getToken();
      let header = 'Bearer ' + token;

      let headers = req.headers.set('Authorization', header);
      req = req.clone({ headers });
    }
    return next.handle(req);
    //.forEach(() => {}, err => this.errorHandler.handleError(err));
    //.catch(err => this.errorHandler.handleError(err));
  }
}

// export const roleInterceptor: HttpInterceptorFn = (req: HttpRequest<any>,next: HttpHandlerFn): Observable<HttpEvent<any>> => {
//   const authService = inject(OAuthService);
//   const token = localStorage.getItem('access_token'); // implement this in your AuthService

//   const isPublic = req.url?.startsWith(environment.keycloakHost)
//   if (isPublic) {
//     console.log(`KC REQ - ${token? 'w/TOKEN':'w/oTOKEN'}`);
//     if(!token) {
//       return next(req); // skip token injection
//     }
//   }

//   const authReq = token
//     ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
//     : req;
//   return next(authReq);
// };

